<template>
    <div class="layout__container layout__padding-20-0">
      <div style="display: flex; align-items: center">
        <div class="layout__padding-clear layout__width-800px">
            <StepGuide :stepCount="2"></StepGuide>
        </div>

        <router-link to="/directmailr" class="link__colour-teal">
          <el-button class="button__background-tickled-pink button__promo selections preserve-bg">
            <h3 class="mb-0">
              20/20 campaigns <br><br>
              from just £22.80
            </h3>
          </el-button>
        </router-link>
      </div>

        <div v-if="errorMessageBool" id="message"
             class="layout__padding-clear component__message-base component__message-fail layout__display-block layout__padding-20-0 layout__width-100 text__align-center">
            Warning - Unsuccessful Uploads! Supported file types: .tiff, .tif, .jpeg, jpg, png
        </div>

        <div class="layout__padding-clear layout__width-90 layout__padding-20-0">
            <table id="fixes">
                <tr v-for="(order, index) in job.orders" v-bind:key="order">
                    <td>
                        <div class="layout__position__relative layout__position-left layout__width-100">
                            <img class="layout__position__relative layout__position-left layout__width-100"
                                 v-bind:src="order.leadImageUrlThumb"/>
                            <img class="component__icon-18-left layout__cursor-pointer" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/bin.png"
                                 v-on:click="removeDialog(order, index)">
                        </div>
                    </td>
                    <td>
                        <div>
                    <span class="layout__width-100">
                            <div class="layout__border__radius-3 layout__width-60 layout__position-left colour__background-teal layout__padding-2-5"><span
                                    class="text__colour-white text__size-15">Basic Photofix</span></div><div
                            class="layout__width-20 layout__border__radius-3 colour__background-light-teal layout__padding-2-5 layout__position-left"><span
                            class="text__colour-white text__size-15">£2.95</span></div>
                        <el-checkbox
                                v-on:change="updateBasicTaskItem(order, 'Brighten Image', fixes.orderFixes[index].brighten_image)"
                                v-model="fixes.orderFixes[index].brighten_image"><div
                                class="text__size-30 icon-brighten layout__padding__right-2 text__colour-teal layout__position-left"></div>Brighten Image
                        </el-checkbox>
                <br>
                        <el-checkbox
                                v-on:change="updateBasicTaskItem(order, 'Add Blue Sky', fixes.orderFixes[index].add_blue_sky)"
                                v-model="fixes.orderFixes[index].add_blue_sky"><div
                                class="text__size-30 icon-sky layout__padding__right-2 text__colour-teal layout__position-left"></div>Add Blue Sky
                         </el-checkbox>
                <br>
                        <el-checkbox
                                v-on:change="updateBasicTaskItem(order, 'Increase Vibrancy', fixes.orderFixes[index].increase_vibrancy)"
                                v-model="fixes.orderFixes[index].increase_vibrancy"><div
                                class="text__size-30 icon-vibrance layout__padding__right-2 text__colour-teal layout__position-left"></div>Increase Vibrancy (Make Grass Green)
                        </el-checkbox>
                <br>
                        <el-checkbox
                                v-on:change="updateBasicTaskItem(order, 'Correct Distortion', fixes.orderFixes[index].correct_distortion)"
                                v-model="fixes.orderFixes[index].correct_distortion"><div
                                class="text__size-30 icon-distortion layout__padding__right-2 text__colour-teal layout__position-left"></div>Correct Distortion</el-checkbox>
                    </span>

                        </div>
                    </td>
                    <td>
                        <div>

                    <span class="layout__width-100">
                        <div class="layout__border__radius-3 layout__width-60 layout__position-left colour__background-red layout__padding-2-5"><span
                                class="text__colour-white text__size-15">Advanced Photofix</span></div><div
                            class="layout__width-20 layout__border__radius-3 colour__background-pink layout__padding-2-5 layout__position-left"><span
                            class="text__colour-white text__size-15">+£3.00</span></div>
                <el-checkbox
                        v-on:change="updateAdvancedTaskItem(order, 'Add Grass', fixes.orderFixes[index].add_grass, fixes.orderFixes[index], index)"
                        v-model="fixes.orderFixes[index].add_grass"><div
                        class="text__size-30 icon-add-grass layout__padding__right-2 text__colour-red layout__position-left"></div>Fix Patchy Grass <span class="text__colour-red">&nbsp;&nbsp;NEW</span></el-checkbox><br>
                <el-checkbox
                        v-on:change="updateAdvancedTaskItem(order, 'Remove Object', fixes.orderFixes[index].remove_object, fixes.orderFixes[index])"
                        v-model="fixes.orderFixes[index].remove_object"><div
                        class="text__size-30 icon-remove layout__padding__right-2 text__colour-red layout__position-left"></div>Remove an Object</el-checkbox>


            </span>
                        </div>
                    </td>
                    <td>
                        <div>
                            <el-button class="button-teal layout__width-100 layout__margin__bottom-6px button__base"
                                       v-on:click=showSupportingDialog(job.id,order,index)
                                       :disabled="fixes.orderFixes[index].supportingDisabled">Upload Supporting Photo(s)
                            </el-button>
                            <div class="component__thumbnails__supporting-container layout__padding-20-0"
                                 v-for="(supporting) in order.supportingAttachments">
                                <img class="component__thumbnails-leading" v-bind:src="supporting.urlThumb"/>
                                <img class="component__icon-18-left layout__cursor-pointer"
                                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/bin.png"
                                     v-on:click="removeSupportingDialog(order.id, supporting.id)">
                            </div>

                            <el-input type="textarea" rows="4"
                                      v-on:blur="updateAdvancedTaskItemInformation(order, fixes.orderFixes[index])"
                                      v-model="fixes.orderFixes[index].information"
                                      :disabled="fixes.orderFixes[index].informationDisabled"
                                      placeholder="Provide a description of the object(s) you would like us to remove."></el-input>
                            <br>
                        </div>
                    </td>
                </tr>
            </table>

            <div class="layout__padding-clear layout__padding-20-0">
                <div class="component__price-title layout__width-100 text__align-right text__colour-teal"
                     v-show="job.orders.length < 5">Upload {{5 - job.orders.length}} more photo<span
                        v-if="job.orders.length < 4">s</span> for 10% off
                </div>
                <div class="component__price-title layout__width-100 text__align-right text__colour-teal"
                     v-show="job.orders.length >= 5 && job.orders.length < 10">Upload {{10 - job.orders.length}} more
                    photo<span v-if="job.orders.length < 9">s</span> for 20% off
                </div>
                <div class="component__price-title layout__width-100 text__align-right text__colour-red"
                     v-show="job.orders.length >= 5">Discount applied at checkout
                </div>

                <div class="component__price-title layout__width-100 text__align-right">Sub Total:
                    £{{this.job.netTotalPrice}}
                </div>
            </div>

            <el-button class="layout__position-left button-teal component__margin-top button__base layout__width-200px"
                       v-on:click="rifatTest = true">Upload more photos
            </el-button>

            <el-button class="layout__position-right button-red component__margin-top button__base layout__width-200px"
                       v-on:click="checkout()">Go to checkout
            </el-button>

            <el-dialog
                    :visible="uploadSupportingFileDialogue"
                    width="500px"
                    :before-close="handleClose"
                    class="">
                <div>

                    <div class="layout__padding-clear">
                        <div class="layout__width-90 layout__padding-clear">
                            <div class="colour__background-white">

                                <div class="text__align-center layout__margin__bottom-6px">

                                        <img class="layout__width-100px"
                                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png">
                                        <h2 class="text__colour-teal layout__padding__top-16px">Supporting Photo(s)<br>Upload</h2>
                                        <p class="text__size-14 layout__margin__bottom-6px">Upload your supporting photos here</p>
                                    </div>

                                    <div class="component__upload-portal__supporting-dropzone"
                                         id="dropzone" @dragover.prevent="ondrag" @drop="ondrop" @dragleave="onleave" v-show="showUploadBool">
                                        <h3 class="text__colour-teal text__align-center text__style-bold-900">Drag and drop<br>your photos here</h3>
                                        <el-button
                                                class="button-red layout__margin__top-10 is__visible-desktop button__base layout__position-center layout__width-150px"
                                                v-on:click="showUpload">Or click to upload
                                        </el-button>
                                        <div class="is__hidden-desktop">
                                            <el-button
                                                    class="button-red layout__margin__top-10 button__base layout__position-center layout__width-150px"
                                                    v-on:click="showUpload">Click to upload
                                            </el-button>
                                        </div>
                                    </div>


                                    <div class="layout__position-center" id="progress" v-show="showProgressBool">
                                        <div class="layout__width-126px layout__height-126px layout__padding-clear layout__margin__top-20px">
                                            <el-progress class="layout__position__absolute" type="circle" :width="126"
                                                         status="exception"
                                                         :percentage="uploadSupportingPercentage"
                                                         color="#00859c"></el-progress>
                                            <img class="component__upload-progress__icon__leading layout__position__absolute"
                                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadProgress.png">
                                        </div>
                                    </div>

                                    <div id="typeError" v-show="showErrorBool" class="text__align-center">
                                        <h1 class="text__colour-red icon-error"></h1>
                                        <h4>There's a problem!</h4>
                                        <p>Attempting to upload unsupported file types: </p>
                                        <div v-for="(errorFile) in fileErrors" v-bind:key="errorFile">
                                            <p>{{errorFile}}</p>
                                        </div>
                                        <br>
                                        <p class="text__colour-teal">Supported file types: jpg, jpeg, tif, tiff, png
                                        </p>
                                        <el-button
                                                class="button-red component__margin-top button__base layout__width-150px"
                                                v-on:click="tryAgain()">Try again
                                        </el-button>
                                    </div>
                                </div>
                        </div>

                    </div>

                    <input type="file" id="supportingFiles" ref="supportingFiles"
                           v-on:change="buttonUpload()"
                           multiple v-show=false>
                    <!-- todo might need a display: block on the mobile -->
                    <div class="layout__padding-20-0 layout__width-100">
                        <!--<h3 class="text__align-center text__colour-teal">Supporting-->
                            <!--Photos</h3>-->
                        <div class="component__thumbnails__supporting-container-dialog"
                             v-for="(supporting, index) in order.supportingAttachments">
                            <img class="component__thumbnails-leading layout__position-left"
                                 v-bind:src="supporting.urlThumb"/>
                            <img class="component__icon-18-left layout__cursor-pointer" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/bin.png"
                                 v-on:click="remove(supporting.id, index)">
                            <p class="layout__padding__top-10px text__align-right">Photo {{index + 1}}</p>
                        </div>
                    </div>
                </div>
                <div class="layout__padding-clear">&nbsp;</div>
                <div class="text__align-center">
                    <el-button id="closeUpload" class="button-red button__base layout__width-150px"
                               v-on:click="toggleUploadSupportingImages()">Close
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog
                    :visible.sync="activateMessageDialogue"
                    width="500px">
                <div class="layout__position-center text__align-center">
                    <h3 class="text__colour-red layout__padding-20-0">There's a problem!</h3>
                    <p class="layout__margin__bottom-6px layout__padding__top-16px">{{ this.errorMessage }}<br></p>
                    <div class="layout__padding-clear">
                        <div class="layout__padding-20-0">
                            <el-button class="button-teal button__base layout__width-150px"
                                       v-on:click="activateMessageDialogue = false">Ok
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
                    :visible.sync="activateDeleteDialogue"
                    width="500px">
                <div class="layout__position-center text__align-center">
                    <h3 class="text__colour-teal layout__padding-20-0">Are you sure you want to delete the photo?</h3>
                    <div class="layout__padding-clear">
                        <div class="layout__padding-20-0">
                            <el-button class="button-teal button__base layout__margin__right-20px layout__width-150px"
                                       v-on:click="removeOrder()">Yes
                            </el-button>
                            <el-button class="button-red button__base layout__width-150px"
                                       v-on:click="activateDeleteDialogue = false">No
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-button class="layout__display-none" id="startPhotofixrUpload"
                       v-on:click="rifatTest = false"></el-button>
            <el-button class="layout__display-none" id="getPfJob" v-on:click="getUpdatedJob()"></el-button>

            <el-dialog
                    :visible.sync="activateDeleteSupportingDialogue"
                    width="500px">
                <div class="layout__position-center text__align-center">
                    <h3 class="text__colour-teal">Are you sure you want to delete <br> the supporting photo?</h3>
                    <div class="layout__position-center layout__padding-20-0">
                        <el-button class="button-teal button__base layout__margin__right-20px layout__width-150px"
                                   v-on:click="removeSupporting()">Yes
                        </el-button>
                        <el-button class="button-red button__base layout__width-150px"
                                   v-on:click="activateDeleteSupportingDialogue = false">No
                        </el-button>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
                    :visible.sync="rifatTest"
                    :close-on-press-escape="false"
                    :close-on-click-modal="false"
                    width="500px">
                <div class="component__login-dialogue layout__padding-clear" v-show="rifatTest">
                    <FileUpload></FileUpload>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import Axios from 'axios';
    import Router from '../../../router';
    import {axios} from '@/mixins/Axios.js';
    import {basket} from '@/mixins/Basket.js';
    import FileUpload from "../../../components/tools/photofixr/FileUpload.vue";
    import {mapGetters, mapActions} from 'vuex';
    import StepGuide from "../../../components/tools/photofixr/StepGuide.vue";

    Vue.use(Element);

    export default {
        name: "Selections",
        mixins: [axios, basket],
        components: {
            FileUpload,
            StepGuide
        },
        props: {
            fileTypeErrors: Array
        },
        computed: {
            ...mapGetters(
                ['evenOrOdd'])
        },
        data() {
            return {
                uploadSupportingFileDialogue: false,
                showProgressBool: false,
                errorMessageBool: false,
                supportingFiles: [],
                uploadSupportingPercentage: 0,
                showUploadBool: true,
                currentOrderId: '',
                taskId: '',
                job: {},
                fixes: {},
                activateMessageDialogue: false,
                activateDeleteDialogue: false,
                activateDeleteSupportingDialogue: false,
                errorMessage: '',
                order: {},
                index: '',
                jobId: '',
                deleteOrderId: '',
                deleteAttachmentId: '',
                showErrorBool: false,
                fileErrors: [],
                uploadMore: false,
                showLogin: false,
                rifatTest: false,
            };
        },
        created() {

            console.log('inside fixes component')
            console.log(this.returnCookie("_token"))

            this.jobId = JSON.parse(window.sessionStorage.getItem('_jobId'))

            const getJob = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId
            Axios.get(getJob, this.returnHeaderUsingToken())
                .then(response => {
                    this.job = response.data
                    this.formatCurrency()
                    console.log(this.job)
                    this.fixes = JSON.parse(window.sessionStorage.getItem('_fixes'))
                })

            if (JSON.parse(window.sessionStorage.getItem('_errors')).length !== 0) {
                // console.log(document.getElementById("message"))

                this.errorMessageBool = true

                this.sleep(5000).then(() => {
                    this.errorMessageBool = false
                    const emptyList = []
                    window.sessionStorage.setItem('_errors', JSON.stringify(emptyList));
                    // this.fileTypeErrors = []
                })
                // document.getElementById("message").innerText = "Warning - Unsuccessful Uploads! Supported file types: .tiff, .tif, .jpeg, jpg"
                // document.getElementById("message").classList.add('component__message-base', 'component__message-fail', 'layout__display-block', 'layout__padding-20-0')
            }


        },
        beforeUpdate() {
            window.sessionStorage.setItem('_fixes', JSON.stringify(this.fixes));
        },
        methods: {
            ...mapActions([
                'incrementPhotofixrTotal'
            ]),
            getUpdatedJob() {

                console.log('******************')
                console.log('getting the updated job')

                console.log(JSON.parse(window.sessionStorage.getItem('_fixes')))

                this.fixes = JSON.parse(window.sessionStorage.getItem('_fixes'))

                this.jobId = JSON.parse(window.sessionStorage.getItem('_jobId'))

                const getJob = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId
                Axios.get(getJob, this.returnHeaderUsingToken())
                    .then(response => {
                        this.job = response.data
                        this.formatCurrency()
                        // console.log(JSON.parse(window.sessionStorage.getItem('_fixes')))
                        // this.fixes = JSON.parse(window.sessionStorage.getItem('_fixes'))
                        // console.log(this.fixes.orderFixes.length)
                    })

                console.log('errors inside id')
                console.log(this.fileTypeErrors.length)

                if (JSON.parse(window.sessionStorage.getItem('_errors')).length !== 0) {
                    this.errorMessageBool = true

                    this.sleep(5000).then(() => {
                        this.errorMessageBool = false
                        // this.fileTypeErrors = []
                        const emptyList = []
                        window.sessionStorage.setItem('_errors', JSON.stringify(emptyList));
                    })
                }
            },
            showUpload() {
                document.getElementById('supportingFiles').click()
            },
            onUpload() {

                let formData = new FormData();
                for (let i = 0; i < this.supportingFiles.length; i++) {
                    const file = this.supportingFiles[i];

                    const fileType = file.type

                    if (fileType !== "image/jpeg" && fileType !== "image/tiff" &&fileType !== "image/png") {
                        console.log('file doesnt match')
                        this.fileErrors.push(file.name)
                        // this.decrementPhotofixrTotal()
                    } else {
                        console.log('file does match')
                        formData.append(file.name, file, file.name);
                        // this.incrementPhotofixrTotal()
                    }
                }

                if (this.fileErrors.length === 0) {
                    this.showUploadBool = false;
                    this.showErrorBool = false;
                    this.showProgressBool = true;
                    this.uploadMore = true
                    this.uploadFiles(formData)
                } else {
                    this.showUploadBool = false;
                    this.showErrorBool = true;
                    this.showProgressBool = false;
                    formData = new FormData();
                }
            },
            uploadFiles(formData) {

                this.showUploadBool = false;
                this.showProgressBool = true;

                const uploadUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId + '/orders/' + this.currentOrderId + '/attachments'
                console.log(uploadUrl)
                Axios.post(uploadUrl, formData, {
                    headers: {
                        "content-type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.returnCookie('_token')
                    },
                    onUploadProgress: function (uploadEvent) {
                        this.uploadSupportingPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                    }.bind(this)
                })
                    .then(response => {
                        console.log('supporting upload complete')
                        console.log(response)
                        this.job = response.data;
                        this.formatCurrency()
                        this.order = this.job.orders[this.index]
                        this.tryAgain()
                        // this.showProgressBool = false
                    });

                this.supportingFiles = [];

            },
            buttonUpload() {
                console.log('making post to api')
                console.log(this.job)

                this.supportingFiles = this.$refs.supportingFiles.files;

                this.onUpload();

            },
            ondrag() {
                document.getElementById('dropzone').className = 'component__upload-portal__supporting-dropzone dragover';
                // event.preventDefault(); // just opening the file
                return false;

            },

            onleave() {
                console.log('on leave')
                document.getElementById('dropzone').className = 'component__upload-portal__supporting-dropzone';
                // event.preventDefault(); // just opening the file
                return false;
            },

            ondrop(event) {
                console.log('onDrop')
                event.stopPropagation();
                event.preventDefault();

                console.log('making post to api')
                console.log(this.job)

                this.supportingFiles = event.dataTransfer.files
                this.onUpload()
                document.getElementById('dropzone').className = 'component__upload-portal__supporting-dropzone';
            },
            removeDialog(order, index) {
                this.activateDeleteDialogue = true
                this.order = order
                this.index = index
            },
            toggleInstructions(order, orderFix) {
                if (orderFix.add_grass === true || orderFix.remove_object === true) {
                    orderFix.informationDisabled = false;
                    orderFix.supportingDisabled = false;
                } else { // can add explicit else if(pf.orderInstructions.bespokeFix.bespokeFixes.length == 0)
                    orderFix.informationDisabled = true;
                    orderFix.supportingDisabled = true;
                    orderFix.information = '';
                }
            },
            updateBasicTaskItem(order, key, value) {
                const category = 'basic'

                if (value === true) {

                    const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id
                        + '/orders/' + order.id
                        + '/taskItems/?taskType=' + key + '&taskCategory=' + category

                    console.log(url)

                    Axios.post(url, {}, this.returnHeaderUsingToken())
                        .then(response => {
                            this.job = response.data;
                            this.formatCurrency()
                        });

                } else { // value is false - item to be removed

                    for (let i = 0; i < order.taskItems.length; i++) {
                        const taskItem = order.taskItems[i]
                        if (taskItem.taskType === key && value == false) {
                            this.taskId = taskItem.id


                            const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id
                                + '/orders/' + order.id
                                + '/taskItems/' + this.taskId

                            Axios.delete(url, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('basic')
                                    console.log(response.data)
                                    this.job = response.data;
                                    this.formatCurrency()

                                });
                        }
                    }
                }
                this.calculateBasicAdvanceOrders();
            },
            updateAdvancedTaskItem(order, key, value, orderFix, index) {
                const category = 'advanced'
                if (value === true) {

                    const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id
                        + '/orders/' + order.id
                        + '/taskItems/?taskType=' + key + '&taskCategory=' + category

                    Axios.post(url, {}, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log('after task add')
                            console.log(this.job)
                            this.job = response.data;
                            this.formatCurrency()
                            console.log(this.job)

                        });


                } else { // value is false - item to be removed
                    for (let i = 0; i < order.taskItems.length; i++) {
                        const taskItem = order.taskItems[i]
                        if (taskItem.taskType === key && value == false) {
                            this.taskId = taskItem.id


                            const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id
                                + '/orders/' + order.id
                                + '/taskItems/' + this.taskId

                            console.log('delete this url ' + url)

                            Axios.delete(url, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('after advanced delete')
                                    console.log(response.data)
                                    this.job = response.data;
                                    this.formatCurrency()

                                });
                        }
                    }
                }
                this.toggleInstructions(order, orderFix);
                this.calculateBasicAdvanceOrders();
            },
            updateAdvancedTaskItemInformation(order, orderFix) {

                console.log('===== before supporting =======')
                console.log(order.id)

                if (orderFix.information !== '') {

                    const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/orders/' + order.id + '/?information=' + encodeURIComponent(orderFix.information)
                    console.log('updating information url')
                    console.log(url)
                    Axios.put(url, {}, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log('after updating task information')
                            console.log(response.data)
                            this.job = response.data;
                            this.formatCurrency()

                        });


                }
            },
            removeOrder() {
                console.log('remove order')
                console.log('index ' + this.index)
                this.fixes.orderFixes.splice(this.index, 1);
                console.log(this.fixes)
                this.job.orders.splice(this.index, 1);
                // this.decrementPhotofixrTotal()
                // alert('deleted row ' + i)

                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.job.id + '/orders/' + this.order.id
                Axios.delete(url, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        this.job = response.data;
                        this.formatCurrency()
                        console.log('job after deleted ' + this.job)
                        this.order = {}
                        sessionStorage.setItem('_uploadedOrders', JSON.stringify(this.job.orders.length))

                        const basketTotals = {
                            photofixr: response.data.orders.length
                        }

                        this.$store.dispatch("incrementPhotofixrTotal", basketTotals)

                        this.index = ''
                        this.activateDeleteDialogue = false
                        this.calculateBasicAdvanceOrders();

                        if (this.job.orders.length === 0) {
                            Router.push({
                                name: '/photofixr'
                            });
                        }
                    });
                // this.index = ''
                // this.activateDeleteDialogue = false
                // this.calculateBasicAdvanceOrders();
                //
                // if (this.job.orders.length === 0) {
                //     Router.push({
                //         name: '/photofixr'
                //     });
                // }

            },
            showSupportingDialog(jobId, order, index) {
                this.jobId = jobId
                this.order = order
                this.currentOrderId = order.id
                this.index = index
                this.uploadSupportingFileDialogue = true


            },
            toggleUploadSupportingImages() {
                this.showUploadBool = true
                this.showProgressBool = false
                this.uploadSupportingFileDialogue = false
            },
            calculateBasicAdvanceOrders() {


                // this.incrementPhotofixrTotal()


                this.fixes.basicOrders = 0
                this.fixes.advanceOrders = 0

                for (let i = 0; i < this.fixes.orderFixes.length; i++) {
                    const orderFix = this.fixes.orderFixes[i];

                    if (orderFix.add_grass == true || orderFix.remove_object == true) {
                        console.log('adding advanced')
                        this.fixes.advanceOrders++
                    } else if (orderFix.brighten_image == true || orderFix.add_blue_sky == true || orderFix.increase_vibrancy == true || orderFix.correct_distortion == true) {
                        console.log('adding basic')
                        this.fixes.basicOrders++
                    }
                }

                console.log('basic ' + this.fixes.basicOrders)
                console.log('advanced ' + this.fixes.advanceOrders)

                console.log('calc basic advance')

            },
            uploadPortal() {
                Router.push({
                    name: '/photofixr',
                });
                // document.getElementById('startPhotofixrUpload').click()
                // this.activeUploadDialogue = true
            },
            checkout() {
                this.activateDeleteDialogue = false
                console.log('checkout method')
                let count = 0

                for (let i = 0; i < this.job.orders.length; i++) {
                    console.log('doing the order evaluation on the checkout button ' + count++)
                    console.log('printing the index ' + i)
                    const order = this.job.orders[i];
                    const orderFix = this.fixes.orderFixes[i];

                    console.log(order.taskItems)
                    if (order.taskItems.length === 0) {
                        let fix = document.getElementById('fixes');
                        console.log(fix)
                        fix.rows[i].classList.add('layout__border-2px-red')
                        this.activateMessageDialogue = true
                        this.errorMessage = 'Please make sure you have specified fixes for all photos, or added comments if you would like to Remove an Object/Fix Patchy Grass'
                        console.log('no task items in order ' + i)
                    } else if (orderFix.remove_object == true && orderFix.information == '') {
                        let fix = document.getElementById('fixes');
                        console.log(fix)
                        fix.rows[i].classList.add('layout__border-2px-red')
                        this.activateMessageDialogue = true
                        this.errorMessage = 'Please add some supporting information for the object removal option'
                        console.log('no information in order ' + i)
                    } else {
                        let fix = document.getElementById('fixes');
                        fix.rows[i].classList.add('layout__border-none')
                    }
                }

                if (this.activateMessageDialogue === false) {
                    if (this.returnCookie('_token') === null) {
                        window.sessionStorage.setItem('_routerFrom', '/photofixr/checkout')
                        document.getElementById('openLoginClosable').click()
                    } else {
                        console.log('going to checkout')
                        Router.push({
                            name: '/photofixr/checkout'
                        });
                    }
                }
            },

            removeSupportingDialog(orderId, attachmentId) {
                console.log(orderId)
                console.log(attachmentId)
                this.activateDeleteSupportingDialogue = true
                this.deleteOrderId = orderId
                this.deleteAttachmentId = attachmentId
            },
            removeSupporting() {
                this.activateDeleteSupportingDialogue = false
                const deleteImageUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId + '/orders/' + this.deleteOrderId + '/attachments/' + this.deleteAttachmentId
                console.log(deleteImageUrl)
                Axios.delete(deleteImageUrl, this.returnHeaderUsingToken())
                    .then(response => {
                        this.job = response.data
                        this.formatCurrency()
                    });
            },
            remove(supportingImageId, index) {
                console.log('removing supporting attachment ' + supportingImageId + ' ' + index)
                const deleteImageUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId + '/orders/' + this.order.id + '/attachments/' + supportingImageId
                console.log(deleteImageUrl)
                Axios.delete(deleteImageUrl, this.returnHeaderUsingToken())
                    .then(response => {
                        this.job = response.data
                        this.formatCurrency()
                        this.order.supportingAttachments.splice(index, 1);
                    });
            },
            tryAgain() {
                this.showUploadBool = true;
                this.showErrorBool = false;
                this.showProgressBool = false;
                this.fileErrors = []
            },
            formatCurrency() {

                this.job.standardItemsPrice = this.job.standardItemsPrice.toFixed(2)
                this.job.bespokeItemsPrice = this.job.bespokeItemsPrice.toFixed(2)
                this.job.netTotalPrice = this.job.netTotalPrice.toFixed(2)
                this.job.vatTotalPrice = this.job.vatTotalPrice.toFixed(2)
                this.job.grossTotalPrice = this.job.grossTotalPrice.toFixed(2)

            },
            handleClose() {
                this.uploadSupportingFileDialogue = false;
            },
            sleep(time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            }
        }


    }
</script>
